export const DirectoryFolderType = {
    PROJECT: 'project',
    VERSION: 'version',
    FOLDER: 'folder',
};

export const fileTypesWithImagePreview = ['png', 'gif', 'jpeg', 'jpg', 'png', 'svg'];
